import axios from "@/libs/axios";

export default {
    namespaced: true,
    state: {
        providers: [],
    },
    getters: {
        _providers(state) {
            return state.providers
        }
    },
    mutations: {
        setProviders(state, providers) {
            state.providers = providers
        },
    },
    actions: {
        async getProviders(context, orderId) {
            return axios.get(`/order/cargo/${orderId}`)
                .then(res => {
                    context.commit('order/changeOrderTracking', [orderId, {}], {root: true})
                    context.commit('setProviders', res.data)
                    return res.data
                })
                .catch(() => {
                    alert('Kargo firmaları çekme hatası')
                    return []
                })
        },
        setProvider(context, [orderId, provider]) {
            return axios.put(`/order/cargo/${orderId}/${provider}`)
                .then(res => {
                    if (res.data.success && res.data.tracking && Object.keys(res.data.tracking).length > 0) {
                        context.commit('order/changeOrderTracking', [orderId, res.data.tracking], {root: true})
                    }
                })
                .catch(() => {
                    alert('Kargo firması değiştirme hatalı')
                })
        }
    }
}
